module.exports = __webpack_public_path__ + "static/media/calendar.0a2e30f1.svg";